import { CalendarSyncEventData } from "@/types/socket"

import { sendAnalyticsEvent } from "@/lib/analytics/amplitude-utils"
import {
  calendarSyncScopeKeyFor,
  markCalendarSyncReconnect,
  receiveCalendarSyncEvent,
} from "./calendar-sync-slice"
import type { AppStore } from "./redux-store"

let calendarSyncStore: AppStore | null = null

export function registerCalendarSyncStore(store: AppStore) {
  calendarSyncStore = store
}

export function dispatchCalendarSyncEvent(event: CalendarSyncEventData) {
  const store = calendarSyncStore
  const storyOperationId = event.metadata?.source_scan_updated_at
  const storyOperationAlreadyTracked =
    event.phase === "preview_story" &&
    storyOperationId != null &&
    Object.values(store?.getState().calendarSyncSlice.scopes ?? {}).some(
      (scope) => {
        const storyPhase = scope.phases.preview_story
        return (
          storyPhase?.state === event.state &&
          storyPhase.metadata?.source_scan_updated_at === storyOperationId
        )
      }
    )
  const scopeKey = calendarSyncScopeKeyFor(
    event.provider,
    event.connection_id,
    event.sync_session_id
  )
  const previousPhase =
    store?.getState().calendarSyncSlice.scopes[scopeKey]?.phases[event.phase]

  store?.dispatch(receiveCalendarSyncEvent(event))
  const appliedPhase =
    store?.getState().calendarSyncSlice.scopes[scopeKey]?.phases[event.phase]

  if (
    store &&
    (event.phase === "initial_sync" || event.phase === "preview_story") &&
    (event.state === "completed" || event.state === "failed") &&
    appliedPhase?.state === event.state &&
    appliedPhase.occurredAt === event.occurred_at &&
    !storyOperationAlreadyTracked &&
    (previousPhase?.state !== event.state ||
      previousPhase.occurredAt !== event.occurred_at)
  ) {
    sendAnalyticsEvent({
      name:
        event.state === "completed"
          ? "CalendarSyncPhaseCompleted"
          : "CalendarSyncPhaseFailed",
      properties: {
        provider: event.provider,
        phase: event.phase,
      },
    })
  }

  if (event.phase === "preview_story") {
    void import("./api/travel-story-api").then(({ travelStoryApi }) => {
      store?.dispatch(travelStoryApi.util.invalidateTags(["TravelStory"]))
    })
  }
}

export function dispatchCalendarSyncReconnect() {
  calendarSyncStore?.dispatch(markCalendarSyncReconnect())
}
